import React from "react";
import {Badge, PageHeadingMeta, PageHeadingMetaItem} from "peggirkit";
import {HomeIcon} from "@heroicons/react/16/solid";
import {useRestaurant} from "@/context/restaurant/RestaurantProvider";
import BadgeIconIndicator from "peggirkit/dist/components/Badge/BadgeElements/Indicator/BadgeIconIndicator";

const LocationPageMeta = () => {
    const {dashboardLocation} = useRestaurant();

    return (
        <PageHeadingMeta>
            <PageHeadingMetaItem>
                <Badge
                    color={"secondary"}
                    indicator={<BadgeIconIndicator icon={HomeIcon}/>}
                >
                    {dashboardLocation.name}
                </Badge>
            </PageHeadingMetaItem>
        </PageHeadingMeta>
    );
};

export default LocationPageMeta;